import { useFormContext, Controller, ControllerProps } from "react-hook-form";

export function FormInput(props: ControllerProps) {
  const { control } = useFormContext();

  return <Controller {...props} control={control} />;
}
